import Vue from 'vue';
import VueRouter from 'vue-router';
import ProjectRouterModule from '../modules/ProjectModule/router/router';

Vue.use(VueRouter);

const routes = [
    ProjectRouterModule,
    {
        path:      '/prihlaseni',
        name:      'login',
        component: () => import('../modules/UserModule/views/LoginView'),
    },
    {
        path: '/',
        name: 'default',
        async beforeEnter(to, from, next) {
            next({name: 'login'});
        }
    },
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
    scrollBehavior(to) {
        if (to.hash) {
            return {selector: to.hash};
        } else {
            return {x: 0, y: 0}
        }
    }
});

export default router;
